import * as types from './types'
import _ from 'lodash'

export default {
  [types.SET_RECOMMENDATION](state, data) {
    if (data !== null) {
      switch (data.name) {
        case 'reset':
          state.reportRecommendations = []
          state.reportRecommendation = JSON.parse(JSON.stringify(state.defaultRecommendation))
          break
        case 'recommendation': {
          state.reportRecommendation = JSON.parse(JSON.stringify(state.defaultRecommendation))
          let last = state.reportRecommendations[state.reportRecommendations.length - 1]
          if (last) {
            if (last.id < 0) {
              state.reportRecommendation.id = last.id - 1
            }
          }
          break
        }
        case 'selected': {
          let found = state.reportRecommendations.find((x) => parseInt(x.reportRecommendation) === parseInt(data.value))
          if (found) {
            state.reportRecommendation = JSON.parse(JSON.stringify(found))
          }
          break
        }
        case 'id':
          state.reportRecommendation.reportRecommendation = parseInt(data.value)
          break
        case 'title':
          state.reportRecommendation.title = data.value
          state.reportRecommendation.isChanged = true
          break
        case 'yearStart': {
          let year = parseInt(data.value)
          if (state.reportRecommendation.yearEnd) {
            if (year > state.reportRecommendation.yearEnd) {
              year = state.reportRecommendation.yearEnd
            }
          }
          state.reportRecommendation.yearStart = year
          state.reportRecommendation.isChanged = true
          break
        }
        case 'yearEnd': {
          let year = parseInt(data.value)
          if (state.reportRecommendation.yearStart) {
            if (year < state.reportRecommendation.yearStart) {
              year = state.reportRecommendation.yearStart
            }
          }
          state.reportRecommendation.yearEnd = year
          state.reportRecommendation.isChanged = true
          break
        }
        case 'systems':
          state.reportRecommendation.systems = data.value
          state.reportRecommendation.isChanged = true
          break
        case 'makes':
          state.reportRecommendation.makes = data.value
          state.reportRecommendation.isChanged = true
          break
        case 'content':
          state.reportRecommendation.content = data.value
          state.reportRecommendation.isChanged = true
          break
        case 'addSystem':
          state.reportRecommendation.systems.push(data.value)
          state.reportRecommendation.systems = _.sortBy(state.reportRecommendation.systems, ['name'])
          break
        case 'addMake':
          state.reportRecommendation.makes.push(data.value)
          state.reportRecommendation.makes = _.sortBy(state.reportRecommendation.makes, ['name'])
          break
        case 'selectSystem':
          console.log('Selected System', data.value)
          break
        case 'selectMake':
          console.log('Selected Make', data.value)
          break
        case 'chkAllSelectedSystems':
          state.reportRecommendation.systems.forEach((element) => {
            element.selected = data.value
          })
          break
        case 'chkAllSelectedMakes':
          state.reportRecommendation.makes.forEach((element) => {
            element.selected = data.value
          })
          break
        case 'removeSystems':
          state.reportRecommendation.systems = state.reportRecommendation.systems.filter((element) => {
            return !element.selected
          })
          break
        case 'removeMakes':
          state.reportRecommendation.makes = state.reportRecommendation.makes.filter((element) => {
            return !element.selected
          })
          break
        default:
          break
      }
      console.log('Set Recommendation', state.reportRecommendation)
    }
  },
  [types.SET_RECOMMENDATIONS](state, data) {
    state.reportRecommendations = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/recommendations/mutations.js